// frontend/utils/structuredData.ts

export const generateArticleStructuredData = (data: any) => {
  const article: any = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: data.title || "Article",
    description: data.description || data.lead || data.seo?.shortDescription,
    url: data.url,
    datePublished: data.publishedAt || data.createdAt,
    dateModified: data.updatedAt || data.publishedAt || data.createdAt,
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": data.url,
    },
  };

  // Add image if available
  if (
    data.image?.data?.attributes?.url ||
    data.blogImage?.data?.attributes?.url
  ) {
    const imageUrl =
      data.image?.data?.attributes?.url ||
      data.blogImage?.data?.attributes?.url;
    article.image = {
      "@type": "ImageObject",
      url: imageUrl,
    };
  }

  // Add author if available (for blog posts)
  if (data.employee?.data?.attributes?.name) {
    article.author = {
      "@type": "Person",
      name: data.employee?.data?.attributes?.name,
    };
  }

  // Add publisher - always Eupry since they publish all content
  article.publisher = {
    "@type": "Organization",
    name: "Eupry",
  };

  return JSON.stringify(article);
};

export const generateBreadcrumbStructuredData = (
  items: Array<{ name: string; url: string }>
) => {
  const breadcrumbList = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };

  return JSON.stringify(breadcrumbList);
};

export const generateCaseBreadcrumbs = (caseData: any, route: any) => {
  const baseUrl = "https://eupry.com";

  return [
    {
      name: caseData.category?.data?.attributes?.name || "Cases",
      url: `${baseUrl}/${caseData.category?.data?.attributes?.slug || "cases"}`,
    },
    { name: caseData.title || "Case", url: `${baseUrl}${route.path}` },
  ];
};

export const generateBlogBreadcrumbs = (postData: any, route: any) => {
  const baseUrl = "https://eupry.com";

  return [
    { name: "Articles", url: `${baseUrl}/articles` },
    {
      name: postData.category?.data?.attributes?.name || "Blog",
      url: `${baseUrl}/${postData.category?.data?.attributes?.slug || "blog"}`,
    },
    { name: postData.title || "Blog Post", url: `${baseUrl}${route.path}` },
  ];
};
